
import React, {FC} from 'react';
import classNames from 'classnames';
import {TimeSlot} from 'components/TimePicker/types';

import Slot from './Slot';

import * as styles from './styles.module.scss';

interface SectionProps {
	timeSlots: TimeSlot[],
	selected?: TimeSlot,
	title?: string,
	truncate?: boolean
	onSelect: (v?: TimeSlot) => void
}

const Section: FC<SectionProps> = ({timeSlots, selected, title, truncate, onSelect}) => {
	return (
		<div className={styles.section}>

			{/* Optional title for this section */}
			{title && (
				<div className={styles.title}>
					{title}
				</div>
			)}

			{/* Grid display of individual slots */}
			<div className={classNames({
				[styles.slots]: true,
				[styles.truncate]: truncate,
			})}>
				{timeSlots.map((slot) => (
					<Slot
						slot={slot}
						selected={slot.id === selected?.id}
						disabled={!slot.canReserve}
						onSelect={onSelect}
						key={slot.id}
					/>
				))}
			</div>
		</div>
	);
};

export default Section;
